import React, { useState } from "react";
import { CiImageOn } from "react-icons/ci";

export default function RenderImages({ property, selectedImage, setSelectedImage, images, setSeeAllclicked, returnImageUrl }) {
    const [mainImageLoaded, setMainImageLoaded] = useState(false);
    const [thumbsLoaded, setThumbsLoaded] = useState({}); // track multiple thumbnails

    // Placeholder image URL for empty slots
    const placeholderImageUrl = "https://s3.amazonaws.com/mlsgrid/images/e587fdb8-82b6-4e77-b260-24785c432d4d.jpeg";

    // Create array of thumbnail images with placeholders
    const getThumbnailsWithPlaceholders = () => {
        const thumbnails = images ? images.slice(1, 5) : [];
        const totalSlots = 4; // We want 4 thumbnail slots
        const placeholdersNeeded = Math.max(0, totalSlots - thumbnails.length);

        // Add placeholder objects to fill remaining slots
        const placeholders = Array(placeholdersNeeded).fill(null).map((_, index) => ({
            isPlaceholder: true,
            url: placeholderImageUrl,
            id: `placeholder-${index}`
        }));

        return [...thumbnails, ...placeholders];
    };

    const thumbnailsToRender = getThumbnailsWithPlaceholders();

    return (
        <div className="tw-mb-3 tw-px-5 lg:tw-px-0 tw-max-w-6xl tw-pt-5">
            {(property?.media ?? property?.images)?.length > 0 ? (
                <section className="tw-gap-2">
                    <div className="tw-flex tw-w-full tw-gap-4 max-sm:tw-flex-col">
                        {/* Main Image */}
                        <div className="tw-w-1/2 max-sm:tw-w-full tw-border-2 tw-border-white tw-rounded-[4px] tw-overflow-hidden">
                            {images && images.length > 0 && (
                                <div className="tw-w-full tw-relative tw-h-full tw-overflow-hidden tw-rounded-[4px] tw-border-1 tw-border-white tw-cursor-pointer" onClick={() => setSeeAllclicked(true)}>
                                    {!mainImageLoaded && (
                                        <div className="tw-absolute tw-inset-0 tw-bg-gray-200 tw-animate-pulse tw-rounded-xl">
                                            <div className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center">
                                                <div className="tw-w-12 tw-h-12 tw-bg-gray-300 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                                                    <CiImageOn className="tw-text-gray-400 tw-text-2xl" />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <img
                                        src={returnImageUrl(selectedImage)}
                                        className={`tw-w-full tw-h-full md:tw-h-[500px] tw-rounded-xl tw-object-cover ${
                                            mainImageLoaded ? "tw-opacity-100" : "tw-opacity-0"
                                        } tw-transition-opacity`}
                                        onLoad={() => setMainImageLoaded(true)}
                                        onError={(e) => {
                                            e.target.src = "https://s3.amazonaws.com/mlsgrid/images/e587fdb8-82b6-4e77-b260-24785c432d4d.jpeg";
                                            setMainImageLoaded(true);
                                        }}
                                    />
                                </div>
                            )}
                        </div>

                        {/* Thumbnail Grid */}
                        <div className="tw-w-1/2 max-sm:tw-w-full tw-grid tw-grid-cols-2 max-sm:tw-grid-cols-1 tw-gap-2">
                            {thumbnailsToRender.map((item, index) => {
                                const isPlaceholder = item?.isPlaceholder;
                                const imageUrl = isPlaceholder ? item.url : returnImageUrl(item);
                                const thumbnailKey = isPlaceholder ? item.id : index;

                                return (
                                    <div
                                        key={thumbnailKey}
                                        className={`tw-rounded-[4px] max-sm:tw-rounded-none tw-w-full tw-h-full max-sm:tw-h-[100px] tw-overflow-hidden tw-relative ${
                                            isPlaceholder ? "tw-cursor-default" : "tw-cursor-pointer"
                                        }`}
                                        onClick={() => !isPlaceholder && setSeeAllclicked(true)}
                                    >
                                        {!thumbsLoaded[thumbnailKey] && (
                                            <div className="tw-absolute tw-inset-0 tw-bg-gray-200 tw-animate-pulse tw-rounded-xl">
                                                <div className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center">
                                                    <div className="tw-w-8 tw-h-8 tw-bg-gray-300 tw-rounded-full tw-flex tw-items-center tw-justify-center">
                                                        <CiImageOn className="tw-text-gray-400 tw-text-lg" />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <img
                                            className={`tw-h-[250px] tw-w-full tw-rounded-xl max-sm:tw-rounded-none tw-object-cover ${
                                                thumbsLoaded[thumbnailKey] ? "tw-opacity-100" : "tw-opacity-0"
                                            } tw-transition-opacity ${isPlaceholder ? "tw-opacity-50" : ""}`}
                                            src={imageUrl}
                                            onLoad={() => setThumbsLoaded((prev) => ({ ...prev, [thumbnailKey]: true }))}
                                            onError={(e) => {
                                                e.target.src = placeholderImageUrl;
                                                setThumbsLoaded((prev) => ({ ...prev, [thumbnailKey]: true }));
                                            }}
                                        />

                                        {/* "See All" Button */}
                                        {index === 3 && images && images.length > 5 && !isPlaceholder && (
                                            <div className="tw-absolute tw-inset-0 tw-rounded-xl tw-bg-black tw-bg-opacity-60 tw-text-white tw-flex tw-items-center tw-justify-center tw-cursor-pointer">
                                                <button className="tw-bg-white tw-text-[12px] tw-text-gray-700 tw-rounded-lg tw-px-3 tw-py-1">
                                                    See more photos
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </section>
            ) : (
                <div className="tw-min-h-[300px] tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-primary tw-bg-[#EFFFFC]">
                    <CiImageOn className="tw-text-[40px]" />
                    No images displayed
                </div>
            )}
        </div>
    );
}
